import Subscription from 'src/models/Subscription';
import storage from 'src/services/storage';

/**
 * @param {import('src/types/subscription-store').SubscriptionsStoreState} state
 * @param {number} estimate
 */
export function setEstimatedSubCount(state, estimate) {
  state.estimatedSubCount = estimate || 1;
  storage.set('subscriptions/estimatedSubCount', state.estimatedSubCount);
}

/**
 * @param {import('src/types/subscription-store').SubscriptionsStoreState} state
 * @param {boolean} isLoading
 */
export function setLoading(state, isLoading) {
  state.subscriptionsLoading = isLoading;
}

/**
 * @param {import('src/types/subscription-store').SubscriptionsStoreState} state
 * @param {import('src/types/subscription-store').SubscriptionData[]} subscriptions
 */
export function setSubscriptions(state, subscriptions) {
  state.subscriptions = subscriptions.map((subscription) => new Subscription(subscription));
  storage.set('subscriptions/estimatedSubCount', subscriptions.length);
}

/**
 * @param {import('src/types/subscription-store').SubscriptionsStoreState} state
 * @param {string} error
 */
export function setSubUpdateError(state, error) {
  state.subUpdateError = error;
}

/**
 * @param {import('src/types/subscription-store').SubscriptionsStoreState} state
 * @param {boolean} isLoading
 */
export function setPlansLoading(state, isLoading) {
  state.plansLoading = isLoading;
}

/**
 * @param {import('src/types/subscription-store').SubscriptionsStoreState} state
 * @param {import('src/types/subscription-store').SubscriptionPlan[]} plans
 */
export function setPlans(state, plans) {
  state.plans = plans;
}

/**
 * @param {import('src/types/subscription-store').SubscriptionsStoreState} state
 */
export function subscriptionsLoaded(state) {
  state.subscriptionsLoaded = true;
}

/**
 * @param {import('src/types/subscription-store').SubscriptionsStoreState} state
 * @param {{ id: string; subscription: import('src/types/subscription-store').SubscriptionData }} payload
 */
export function updateSubscriptionById(state, { id, subscription }) {
  /** @type {import('src/types/subscription-store').SubscriptionData[]} */
  const subscriptions = [];

  state.subscriptions.forEach((existingSubscription) => {
    if (existingSubscription.id === id) {
      subscriptions.push(new Subscription({ ...subscription }));
    } else {
      subscriptions.push(existingSubscription);
    }
  });

  state.subscriptions = subscriptions;
}
